// eslint-disable-next-line
import { myTokenType, orgTypes, userType, locationTypes, categoryTypes, itemTypes, stockTypes, regionTypes, orderTypes, notificationTypes, reasonTypes, noticeBannerTypes, vendorTypes, masterVendorTypes, organizationVendorTypes } from './proptypes';

const initUser: userType = {
  id: '',
  firstName: '',
  lastName: '',
  emailAddress: '',
  roles: [],
  isActive: true,
  created: new Date(),
};

const initOrganization: orgTypes = {
  id: '',
  name: '',
  userOrganizations: [],
  isActive: true,
};

const initLocation: locationTypes = {
  id: '',
  name: '',
  clubCode: '',
  phoneNumber: '',
  abcNumber: 0,
  vendorConfig: {},
  hasLocationPassword: false,
  customerNumber: '',
  mfusaShipId: '',
  region: null,
  userOrgs: [],
  isActive: true,
};

const initRegion: regionTypes = {
  id: '',
  name: '',
  locations: [],
  parentGroup: null,
  userOrgs: [],
  isActive: true,
};

const initCategory: categoryTypes = {
  id: '',
  name: '',
  organizationId: '',
  countItem: 0,
  parentId: null,
  parent: null,
  children: [],
  isActive: true,
};

const initVendor: vendorTypes = {
  id: '',
  name: '',
  description: '',
  format: 'CSV',
  remitEmail: '',
  organizationId: '',
  countItem: 0,
  isActive: true,
};

const initMasterVendor: masterVendorTypes = {
  id: '',
  name: '',
  description: '',
  isActive: true,
};

const initOrganizationVendor: organizationVendorTypes = {
  id: '',
  vendorId: '',
  organizationId: '',
  name: '',
  description: '',
  remitEmail: '',
  format: undefined,
  integration: undefined,
  url: '',
  orderFrequency: null,
};

const initItem: itemTypes = {
  id: '',
  name: '',
  organizationId: '',
  isActive: true,
  sku: '',
  vendorConfig: {},
  upc: '',
  bulkUpc: '',
  unitCost: 0,
  unitPrice: 0,
  seasonalStartDate: null,
  seasonalEndDate: null,
  seasonalYear: null,
};

const initStock: stockTypes = {
  id: '',
  name: '',
  locationId: '',
  location: null,
  itemId: '',
  item: null,
  quantityOnHand: 0,
  minimumStock: null,
};

const initReason: reasonTypes = {
  id: '',
  name: '',
  organizationId: '',
  created: ''
};

const initNoticeBanner: noticeBannerTypes = {
  id: '',
  message: '',
  organizationId: '',
  created: ''
};

const initOrder: orderTypes = {
  id: '',
  name: '',
  locationId: '',
  location: null,
  status:'Draft',
  orderedOn: new Date(),
  purchaseOrderItems: null
};

const initNotification : notificationTypes = {
  id: '',
  message: '',
  created: ''
}

const initToken: myTokenType = {
  token: '',
  expiredDate: '',
  status: 'Active',
};
export { initUser, initOrganization, initToken, initLocation, initRegion, initCategory, initItem, initStock, initReason, initVendor, initMasterVendor, initOrganizationVendor, initOrder, initNotification, initNoticeBanner };
